import React from 'react';
import { map, isEqual, filter } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { Form } from 'modules/form';
import { button as Button } from 'modules/button';
import { getDisplayValue } from 'resolvers/formatValue';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { editMemberSecuritySettingsPassword as EditMemberSecuritySettingsPassword } from 'ui/views/widgets/editMemberSecuritySettingsPassword';
 *
 * // render
 * <EditMemberSecuritySettingsPassword propName='propValue'/>
 */
export const editMemberSecuritySettingsPassword = ( props ) => {

    const actions = filter( props.actions, ( action ) => {
        if( 'add' === props.mode ) {
            return 'edit' !== action.name;
        } else {
            return 'save' !== action.name;
        }
    } );
    
    return (
        <div className='ui-edit-member-security-settings-password'>
            <div className='ui-edit-member-security-settings-password__header'>

                {/* title for the modal */}
                <div className='ui-edit-member-security-settings-password__header__title'>
                    { getLabel( props.addTitle ) }
                </div>

                {/* close button */}
                <div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff'/>
                </div>
            </div>

            <div className='ui-edit-member-security-settings-password__body'>

				{/* title for the drug preference */}
                <div className='ui-edit-member-security-settings-password__body__description'>
                    <div>{ props.message }</div>
                    <div className='ui-edit-member-security-settings-password__body__description__content'>
                        <div className='ui-edit-member-security-settings-password__body__description__content__title'>{ getLabel( props.field.title ) }</div>
                        <div  className='ui-edit-member-security-settings-password__body__description__content__value'>
                        { getDisplayValue(
                            {
                            type: props.field.type,
                            value: props.itemData.values[ props.field.name ],
                            }
                        ) }
                        </div>
                    </div>
                </div>
                    <Form
                       values={ props.itemData.values } // default values
                        isValid={ false }
                        mode={ props.mode }
                        onSubmit={ () => {
                            props.onSumbitClick();
                        } }
                        >
                             { ( { onSumbit } = {} ) => {

                            return (
                                <form
                                    onSubmit={ onSumbit }
                                    className='ui-edit-member-security-settings__body__form'
                                >
                                <div className='ui-edit-member-security-settings-password__body__form__actions'>
                                    { map( actions, action => {
                                        return (
                                            <Button
                                                key={ action.name }
                                                id= { action.name }
                                                type= { 'cancel' !== action.name ? 'submit' : 'button' }
                                                { ...action }
                                                outline={ 'cancel' === action.name ? true: false }
                                                size='medium'
                                                className='ui-edit-member-security-settings__body__form__actions__action'
                                                onClick = { isEqual( 'cancel', action.name ) ?  () => props.onCancelClick() : null }
                                            />
                                        );
                                    } ) }
                                </div>
                                </form>
                                );
                            } }
                        </Form>
			</div>
        </div>
   
    );
};

// set display name
editMemberSecuritySettingsPassword.displayName = 'editMemberSecuritySettingsPassword';

// set default props
editMemberSecuritySettingsPassword.defaultProps = {};

// prop types
editMemberSecuritySettingsPassword.propTypes = {};
